import React from 'react';
import styles from './BulletBoxItem.module.scss';

interface BulletBoxItemProps {
  iconSrc: string;
  title: string;
  content: string;
  linkText: string;
  linkUrl: string;
}

export default function BulletBoxItem({
  iconSrc,
  title,
  content,
  linkText,
  linkUrl
}: BulletBoxItemProps) {
  return (
    <div className={styles.bulletItem}>
      <div className={styles.titleWrapper}>
        <img 
          decoding="async" 
          aria-hidden="true" 
          alt="" 
          src={iconSrc}
        />
        <h3>{title}</h3>
      </div>
      <p>{content}</p>
      <a className={styles.arrowBtn} href={linkUrl}>
        {linkText}
      </a>
    </div>
  );
} 